export class Monitor {
    private clockStart: number;
    videoViewLogID: number;
    private monitorIntervalId: number;

    constructor() {
        const self = this;
        this.videoViewLogID = 0;
        this.clockStart = 0;
        this.monitorIntervalId = 0;
        window.addEventListener("unload", function (evt) {
            self.postComplete();
        }, false);
    }

    async create(VideoViewItemID: number) {
        await this.postComplete();

        const self = this;

        const monitorurl = `/Monitor/Create/${VideoViewItemID}`;
        try {
            const response = await fetch(monitorurl, {
                method: "POST",
            });

            if (!response.ok) {
                throw new Error("Network response was not ok");
            }

            const data = await response.text(); // Assuming `data` is returned as a string

            if (data) {
                self.videoViewLogID = parseInt(data);
                self.startClock();
            }
        } catch (error) {
            console.error(
                "There was a problem with the fetch operation:",
                error,
            );
        }
    }

    // Usually created in javascript
    async createExisting(vvlid: number) {
        await this.postComplete();

        this.videoViewLogID = vvlid;
        this.startClock();
    }

    async updateMonitor() {
        if (this.videoViewLogID) {
            const diffSecs = (this.getTimeDiff() / 1000).toFixed(0);
            const url =
                `/Monitor/Update/${this.videoViewLogID}?sec=${diffSecs}`;
            await fetch(url, {
                method: "POST",
            });
        }
    }

    // manually stop a monitor
    async stop() {
        await this.postComplete();
    }

    // Starts the clock
    startClock() {
        const startday = new Date();
        this.clockStart = startday.getTime();
        this.monitorIntervalId = window.setInterval(
            () => this.updateMonitor(),
            10000,
        );
    }

    // If we have an unload beacon, then add a log entry
    private async postComplete() {
        if (this.clockStart && this.videoViewLogID) {
            const data = new FormData();
            const timeDiff = this.getTimeDiff();

            data.append("videoviewlogpublicid", this.videoViewLogID.toString());
            data.append("ms", timeDiff.toString());

            if (navigator.sendBeacon) {
                if (!navigator.sendBeacon("/Monitor/Complete", data)) {
                    await this.postBeaconFallback(data);
                }
            } else {
                await this.postBeaconFallback(data);
            }
        }

        if (this.monitorIntervalId) {
            window.clearInterval(this.monitorIntervalId);
            this.monitorIntervalId = 0;
        }

        // don't allow to be posted multiple times
        this.videoViewLogID = 0;
        this.clockStart = 0;
    }

    // If for some reason beacons aren't working
    async postBeaconFallback(data: FormData) {
        await fetch("/Monitor/Complete", {
            method: "POST",
            body: data, // `data` is already a FormData object, so we don't need to set contentType or processData
        });
    }

    // calculate the elapsed second
    getTimeDiff(): number {
        const myTime = new Date();
        return myTime.getTime() - this.clockStart;
    }
}
